import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { BankCardIcon, CashIcon } from "@/shared/icons";

type Props = {
  type: "cash" | "bank";
  className?: string;
  value: string;
};

export default function HudMoney({ className, value, type }: Props) {
  const { t } = useTranslation("hud");

  return (
    <div className={clsx("h-[4.125rem] w-[8.625rem] rounded-[0.5rem] bg-dark-900/60", className)}>
      <div className="flex flex-col p-3 h-full w-full justify-center bg-gradient-to-br from-white/5 to-transparent rounded-[0.4rem]">
        <div className="w-full flex items-center text-14 font-bold gap-1">
          <div className="w-max-[7rem] overflow-hidden whitespace-nowrap text-ellipsis">
            {value}
          </div>{" "}
          &#8381;
        </div>
        <div className="h-[1px] w-[5.125rem] shrink-0 bg-gradient-to-r from-white/10 to-transparent my-1" />
        <div className="flex items-center justify-between">
          <div className="text-11 font-bold text-white/70 uppercase">
            {type === "cash" ? t("hud.cash") : t("hud.bankCard")}
          </div>
          {type === "cash" ? (
            <CashIcon size={20} className="text-white" />
          ) : (
            <BankCardIcon size={20} className="text-white" />
          )}
        </div>
      </div>
    </div>
  );
}
